<alliance-feature-header [positionMode]="state.positionMode">
  <ng-template #centerContent>
    <div class="header-shadow-container">
      <div class="content-container santa-flex santa-justify-between santa-items-center">
        <nav class="santa-flex santa-flex-grow santa-items-center santa-space-x-10 1000:santa-space-x-20">
          <alliance-ats-logo
            class="santa-py-10 santa-flex-shrink-0"
            [full]="!state.isLoggedIn || !state.hasAccess"
            atsAnalyticsPushEventOnClick
            [event]="{ event: HEADER_NAVIGATION_EVENT, labelParam: 'logo' }"
          ></alliance-ats-logo>

          <div *ngIf="state.hasAccess" class="santa-flex santa-justify-between">
            <div class="santa-flex santa-items-center 1000:santa-space-x-40">
              <div class="santa-flex santa-items-center">
                <ng-container *ngFor="let link of state.navigationLinks; trackBy: trackByFn; let last = last; let count = count">
                  <alliance-ats-static-directive-tooltip
                    class="santa-block"
                    [tooltipTemplate]="tooltipTemplate"
                    [offset]="0"
                    [parents]="link.tooltipParents || []"
                    [renderTooltip]="true"
                    [applyChangeOnClick]="true"
                  >
                    <a
                      class="header-link"
                      [ngClass]="{ 'santa-hidden': link.isHidden }"
                      [routerLink]="link.path"
                      routerLinkActive="activated"
                      #rla="routerLinkActive"
                      atsAnalyticsPushEventOnClick
                      [event]="link.event"
                    >
                      <alliance-icon [name]="rla.isActive ? link.activeIcon : link.defaultIcon" [inheritColor]="!rla.isActive"></alliance-icon>

                      <span class="link-label" [ngClass]="{ 'santa-ml-10': !!link.label }">
                        {{ link.label }}
                      </span>
                    </a>
                  </alliance-ats-static-directive-tooltip>
                </ng-container>
              </div>

              <ng-container *ngFor="let navigationButton of state.navigationButtons; trackBy: trackByFn">
                <alliance-ats-static-directive-tooltip
                  class="santa-block"
                  [tooltipTemplate]="tooltipTemplate"
                  [offset]="20"
                  [parents]="navigationButton.tooltipParents || []"
                  [renderTooltip]="true"
                  [applyChangeOnClick]="true"
                >
                  <a class="header-button" [routerLink]="navigationButton.path" (click)="navigationButton.action()">
                    {{ navigationButton.label }}
                  </a>
                </alliance-ats-static-directive-tooltip>
              </ng-container>
            </div>
          </div>
        </nav>

        <div class="santa-min-w-0 santa-flex santa-items-center santa-ml-5">
          <santa-button
            *ngIf="!state.isLoggedIn"
            type="mass"
            mode="no-x-indent"
            [routerLink]="['/login']"
            atsAnalyticsPushEventOnClick
            [event]="{ event: HEADER_NAVIGATION_EVENT, labelParam: 'login' }"
          >
            <p class="santa-flex santa-items-center santa-space-x-10 santa-whitespace-nowrap santa-text-black-700">
              <alliance-icon [name]="ICONS.IconLogin20.name" [inheritColor]="true"></alliance-icon>
              <span class="santa-typo-secondary">{{ translations.login | translate }}</span>
            </p>
          </santa-button>
          <ng-container *ngIf="state.hasAccess">
            <lib-lazy-manager-panel *ngIf="state.showManager" class="santa-w-full empty:santa-hidden" [style.height.px]="60"></lib-lazy-manager-panel>
            <lib-lazy-navigation-panel [ngClass]="{ shrinked: state.showManager }" class="navigation-panel empty:santa-hidden" [style.height.px]="60"></lib-lazy-navigation-panel>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #botContent>
    <ng-container *ngIf="state.bottomContent as bottomContent">
      <ng-container *ngIf="state.subHeaderMode === HeaderSubHeaderModeEnum.custom; else defaultSubHeader" [cdkPortalOutlet]="bottomContent"></ng-container>

      <ng-template #defaultSubHeader>
        <div class="header-shadow-container">
          <div class="content-container">
            <ng-container [cdkPortalOutlet]="bottomContent"></ng-container>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </ng-template>
</alliance-feature-header>

<ng-template #tooltipTemplate>
  <div class="santa-text-white santa-pointer-events-none" [style.width.px]="248" (click)="$event.preventDefault(); $event.stopPropagation()">
    <div class="tooltip-img-container">
      <img [src]="staticTooltipImage" width="auto" height="60" loading="eager" alt="" />
    </div>
    <p class="santa-typo-regular">{{ state.tooltipText }}</p>
  </div>
</ng-template>
